import panelModule from "./r2PanelModule"
import viewsPanel from "./viewsPanel.html"
import angular from "angular"

panelModule.directive("nlgViewsPanel", function () {
    return {
        restrict: "E",
        template: viewsPanel,
        scope: {
            firstViewTitle: "@",
            secondViewTitle: "@",
            tdn: "<?",
            storageFunctions: "="
        },
        transclude: {
            firstView: "firstView",
            secondView: "secondView"
        },
        controller($scope, $element, $window) {
            $scope.preferences = $scope.storageFunctions.getPreferences()

            $scope.gridView = $scope.preferences["panel"] === "grid-view"
            $scope.halfWidthBasket = false
            $scope.halfWidthTripList = false
            $scope.showBasket = {
                "order": $scope.preferences.viewType.includes("order"),
                "trip": $scope.preferences.viewType.includes("trip")
            }

            $scope.$watchCollection("showBasket", function () {
                $scope.selectedBaskets = []
                angular.forEach($scope.showBasket, function (value, key) {
                    if (value) {
                        $scope.selectedBaskets.push(key)
                    }
                })
                $scope.preferences["viewType"] = $scope.selectedBaskets
                $scope.storageFunctions.savePreferences($scope.preferences)
                updateHalfWidthState()
            })

            $scope.shouldDisabled = (basket) => {
                return $scope.selectedBaskets.length === 1 && $scope.selectedBaskets.indexOf(basket) !== -1
            }

            $scope.getPanelMaxHeight = function () {
                let windowHeight = $window.innerHeight
                let firstPanelTop = $element.find(".viewPanelContents").offset().top
                let buttonsBarHeight = $element.siblings().outerHeight(true)
                let buttonsBarMargin = 10
                let marginInsidePanel = 63
                let marginOutsidePanel = 10
                let heightSections = getNumberOfHeightSections()
                let blankSpace = windowHeight - firstPanelTop - buttonsBarHeight - buttonsBarMargin - (marginInsidePanel + marginOutsidePanel) * heightSections
                let basketContainerHeight = blankSpace / heightSections + "px"
                angular.element("nlg-basket")
                    .parent()
                    .css({
                        "max-height": basketContainerHeight,
                        height: basketContainerHeight
                    })
            }
            angular.element($window).resize($scope.getPanelMaxHeight)

            $scope.useListView = function () {
                $scope.gridView = false
                updatePanelPreferences("list-view")
                updateHalfWidthState()
            }

            $scope.useGridView = function () {
                $scope.gridView = true
                updatePanelPreferences("grid-view")
                updateHalfWidthState()
            }

            function getNumberOfHeightSections() {
                return $scope.gridView ? Math.max($scope.selectedBaskets.length - 1, 1) : $scope.selectedBaskets.length
            }

            function updateHalfWidthState() {
                $scope.halfWidthBasket = $scope.gridView && $scope.selectedBaskets.length === 2
                $scope.halfWidthTripList = $scope.gridView && $scope.showBasket.trip && $scope.selectedBaskets.length === 2
            }

            function updatePanelPreferences(panelView) {
                $scope.preferences["panel"] = panelView
                $scope.storageFunctions.savePreferences($scope.preferences)
            }
        }
    }
})